var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRegistersIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.6667H4.21429M12.7857 8.11111H4.21429M12.7857 2.77778C14.5609 2.77778 16 3.97169 16 5.44444V12.7333C16 14.2268 16 14.9735 15.6497 15.544C15.3415 16.0457 14.8498 16.4537 14.245 16.7094C13.5574 17 12.6573 17 10.8571 17H6.14286C4.34269 17 3.4426 17 2.75503 16.7094C2.15022 16.4537 1.6585 16.0457 1.35034 15.544C1 14.9735 1 14.2268 1 12.7333V5.44444C1 3.97169 2.43908 2.77778 4.21429 2.77778M4.21429 4.55556H12.7857V2.51743C12.7857 2.11498 12.593 1.72902 12.25 1.44444C11.907 1.15987 11.4418 1 10.9567 1H6.04333C5.55824 1 5.09301 1.15987 4.75 1.44444C4.40699 1.72902 4.21429 2.11498 4.21429 2.51743V4.55556Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRegistersIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/registersIcon.5b293cb751b548ee58249cd83b8e931b.svg";